(function () {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * @param {HTMLElement} el
   * @param {{ delay?: number, speed?: number }} [options]
   */
  function typeElement(el, options = {}) {
    const text = el.dataset.typingText || el.textContent.trim();
    if (!text) return Promise.resolve();

    const delay = options.delay ?? 0;
    const speed = options.speed ?? 72;

    if (prefersReduced) {
      el.textContent = text;
      return Promise.resolve();
    }

    el.dataset.typingText = text;

    return new Promise((resolve) => {
      setTimeout(() => {
        el.textContent = '';
        el.classList.add('typing-cursor');

        let index = 0;

        const tick = () => {
          if (index < text.length) {
            el.textContent += text.charAt(index);
            index += 1;
            setTimeout(tick, speed);
            return;
          }

          el.classList.remove('typing-cursor');
          resolve();
        };

        tick();
      }, delay);
    });
  }

  /**
   * @param {ParentNode} root
   * @param {string} selector
   * @param {{ baseDelay?: number, stagger?: number, speed?: number }} [options]
   */
  function initTyping(root, selector, options = {}) {
    const baseDelay = options.baseDelay ?? 200;
    const stagger = options.stagger ?? 100;
    const speed = options.speed ?? 72;

    root.querySelectorAll(selector).forEach((el, idx) => {
      if (!(el instanceof HTMLElement)) return;
      const text = el.textContent.trim();
      if (!text) return;
      el.dataset.typingText = text;
      typeElement(el, { delay: baseDelay + idx * stagger, speed });
    });
  }

  window.TypingText = { typeElement, initTyping };
})();
